import React from "react";
import {createRoot} from "react-dom/client";
import {RakutenCategories} from "./RakutenCategories";

document.querySelectorAll('.service-category').forEach(el => {

    el.addEventListener('click', (e) => {
        e.preventDefault();
        const categoryId = el.getAttribute('data-categoryId');
        const amazonCategoryId = el.getAttribute('data-amazonCategoryId');
        const element = document.getElementById('service-category-dialog-root');
        const root = createRoot(element);
        const onClose = () => {
            element.remove();
            // recreate the container
            const el = document.createElement('div');
            el.id = 'service-category-dialog-root';
            document.body.appendChild(el);
        }
        root.render(<RakutenCategories onClose={onClose} categoryId={categoryId} amazonCategoryId={amazonCategoryId}/>);
        return false;
    });
});